'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {
	(0, _jquery2.default)("#import-new-report-btn", this).click(function () {
		(0, _jquery2.default)(".error, .result-message").html("");
	});

	(0, _jquery2.default)("#importCartItemsBtn", this).click(function () {
		(0, _jquery2.default)(".error, .result-message").html("");
		(0, _jquery2.default)("#Eans").val("");
		(0, _jquery2.default)(".dropzone").removeClass("dz-started");
		(0, _jquery2.default)(".dropzone").html('' + Resx.DropZone.Message);
	});

	(0, _jquery2.default)("#importStockStateBtn", this).click(function () {
		(0, _jquery2.default)(".result-message").html("");
	});

	(0, _jquery2.default)("#importDealerOrdersBtn", this).click(function () {
		(0, _jquery2.default)(".result-message").html("");
	});

	(0, _jquery2.default)('#submit-form-btn').click(function () {
		var fromFile = (0, _jquery2.default)('div.active > input.from-file').val();
		if (fromFile === "true") {
			(0, _jquery2.default)("#FromFile").val(true);
		} else {
			(0, _jquery2.default)("#FromFile").val(false);
		}
		(0, _jquery2.default)(this).closest("form").submit();
	});

	(0, _jquery2.default)(document).ready(function () {
		if ((0, _jquery2.default)("#FromFile").val() === 'true') {
			(0, _jquery2.default)("#FromText").removeClass("active");
			(0, _jquery2.default)("#from-text-item").removeClass("active");

			(0, _jquery2.default)("#FromFileDiv").addClass("active");
			(0, _jquery2.default)("#from-file-item").addClass("active");
		}
	});
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)("DropZone");

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/clearModal.js
// module id = 1061
// module chunks = 1